<template>
  <div class="py-5 md:px-5">
    <PageHeader class="max-w-4xl" :title="`${$route.params.id ? 'Edit' : 'Create'} Addon`" :back-step="true" />
    
    <div class="max-w-4xl mx-auto">
      <div class="p-6 card">
        <Loading v-if="$route.params.id && loading" />
        <form @submit.prevent="upsertAddon()" v-else>
          <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
            <div v-for="error in form_errors" :key="error.message">
              {{ error.message }}
            </div>
          </div>
          <div class="grid gap-6 md:grid-cols-3">
            <div class="md:col-span-2">
              <fieldset class="form-group">
                <label for="" class="form-label">
                  Name
                </label>
                <input type="text" class="form-input" v-model="form.name">
                <validations :errors="errors" field="name" />
              </fieldset>

              <fieldset class="form-group">
                <label for="" class="form-label">
                  Description
                </label>
                <textarea class="form-textarea" v-model="form.description"></textarea>
                <validations :errors="errors" field="description" />
              </fieldset>

              <fieldset class="form-group">
                <label for="" class="form-label">
                  Price
                </label>
                <div class="relative rounded-md">
                  <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                    <span class="text-gray-400">
                      {{ account.currency }}
                    </span>
                  </div>
                  <currency-input id="price" class="w-full pl-8 text-right form-input" placeholder="0.00" :currency="null" auto-decimal-mode value-as-integer v-model="form.price" />
                </div>
                <validations :errors="errors" field="price" />
              </fieldset>
            </div>

            <div>
              <fieldset class="form-group">
                <label for="" class="form-label">
                  Image
                </label>
                <div class="flex flex-col p-4 overflow-hidden bg-gray-100 rounded-md">
                  <div class="flex-grow h-64 min-h-0">
                    <img :src="form.image" class="object-contain w-full rounded">
                  </div>

                  <div>
                    <ImageUploader bucket="fleetbeacon-addons" class="flex items-center justify-center w-full h-12 text-sm text-gray-500 hover:bg-white hover:bg-opacity-50 hover:text-indigo-500" @uploaded="updateImage">
                      Upload <fa :icon="['far', 'arrow-to-top']" class="ml-2" />
                    </ImageUploader>
                  </div>
                </div>
                <!-- <input type="text" class="mt-4 form-input" v-model="form.image"> -->
                <validations :errors="errors" field="image" />
              </fieldset>
              
              <fieldset class="form-group">
                <label for="" class="form-label">
                  Status
                </label>
                <radio-group
                  v-model="form.status"
                  :options="[
                    { label: `Draft`, value: 'draft' },
                    { label: `Active`, value: 'active' }
                  ]" />
                <validations :errors="errors" field="status" />
              </fieldset>
            </div>
          </div>
          <button class="mt-4 btn btn-primary" v-submitting="submitting">
            {{ $route.params.id ? 'Save' : 'Create' }} Addon
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageUploader from '@/components/ImageUploader.vue'

export default {
  name: 'AddonForm',

  components: {
    ImageUploader
  },

  created () {
    if (this.$route.params.id) {
      this.getAddon()
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      submitting: false,
      form_errors: [],
      errors: [],
      form: {
        name: '',
        description: '',
        price: '',
        image: '',
        status: 'draft'
      }
    }
  },

  methods: {
    updateImage (url) {
      this.form.image = url
    },

    async getAddon () {
      try {
        const { data } = await this.$api.get(`/account/${this.$route.params.account}/addons/${this.$route.params.id}`)
        this.form = data.addon
        this.loading = false
      } catch (error) {
        this.$toasted.error('There was a problem fetching this addon.')
        console.error(error)
      }
    },

    async upsertAddon () {
      try {
        this.submitting = true
        if (this.$route.params.id) {
          await this.$api.patch(`/account/${this.$route.params.account}/addons/${this.$route.params.id}`, this.form)
        } else {
          await this.$api.post(`/account/${this.$route.params.account}/addons/`, this.form)
        }
        this.$toasted.show(`Addon "${this.form.name}" ${this.$route.params.id ? 'Updated' : 'Created'}`)
        this.$router.push({ name: 'AddonList' })
      } catch (error) {
        this.$toasted.error('There was a problem saving this addon.')
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>